/*
 *******************************************************************************
 *
 *  Filename:   @/pages/system/Users/Columns.js
 *
 *  Syntax:
 *
 *  Synopsis:   Column formatting.
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Wednesday, April 12, 2023 - 2:21 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { Box } from "@mui/material";
import FormattedDate from "@/pages/renderers/FormattedDate";
import FullName from "@/pages/renderers/FullName";
import AgAction from "@/pages/renderers/AgAction";

import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

/*  AG Grid Settings */
const columnCentered = {
  headerClass: "text-center",
  cellStyle: {
    textAlign: "center",
  },
};

export const columns = (handleEditClick, handleDeleteClick) => [
  {
    field: "LASTNAME",
    headerName: "User",
    cellRenderer: FullName,
    autoHeight: true,
    wrapText: true,
    flex: 1,
  },
  {
    field: "COMPANY",
    headerName: "Company",
  },
  {
    field: "USERSTATUS",
    headerName: "Status",
    headerClass: "center-aligned-group-header",
    width: 200,
    ...columnCentered,
  },
  {
    field: "USERID",
    headerName: "Actions",
    sortable: false,
    width: 150,
    filter: false,
    cellRenderer: AgAction,
    cellRendererParams: {
      onEditClick: handleEditClick.bind(this),
      onDeleteClick: handleDeleteClick.bind(this),
    },
    ...columnCentered,
  },
];
